import { Button } from "@capioweb/ui-components"
import React from "react"

interface FilterItemProps {
	checked?: boolean
	onClick: (item: string) => void
	description: string
}

export const FilterItem: React.FC<FilterItemProps> = ({
	checked,
	onClick,
	description,
}) => (
	<Button
		onClick={() => {
			onClick(description)
		}}
		variant={checked ? "navy" : "white"}
		size={"small"}
	>
		{description}
	</Button>
)
